import {AppSettingApi} from '../AppSettingApi';
import {BaseWebApiDAO} from './BaseWebApiDAO';
import {toCamel} from '../Util/SnakeCamelUtil';
import {BaseService} from '../Service/BaseService';
import {ExamAfterProcessInitialDataDTOInterface} from '../DTO/ExamAfterProcessInitialDataDTOInterface';
import {UserDeliveryAddressDTOInterface} from '../DTO/UserDeliveryAddressDTOInterface';
import {ExamAfterProcessDTOInterface} from '../DTO/ExamAfterProcessDTOInterface';

/**
 * 予約データDAO
 */
export class ExamAfterProcessDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}


	/**
	 * レンダリングに必要なデータを取得
	 * @param paymentId
	 */
	public async getInitialData(paymentId: number): Promise<ExamAfterProcessInitialDataDTOInterface|null> {

		this.log('ExamAfterProcessDAO::getInitialData()');
		const request = {
			t: this.token,
			payment_id: paymentId,
		};
		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_GET_INITIAL_DATA, request);

		if (ret === null) {
			return null;
		}

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}


	/**
	 * 保存
	 * @param examAfterProcess
	 */
	public async saveExamAfterProcess(examAfterProcess: ExamAfterProcessDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::saveExamAfterProcess()');
		const request = {
			t: this.token,
			id: examAfterProcess.id,
			payment_id: examAfterProcess.paymentId,
			reservation_id: examAfterProcess.reservationId,
			prescription_address_id: examAfterProcess.prescriptionAddressId,
			prescription_delivery_target: examAfterProcess.prescriptionDeliveryTarget,
			medicine_address_id: examAfterProcess.medicineAddressId,
			status: 0,
			hash: ''
		};
		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_SAVE, request);
		this.log(ret);
		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * お薬送付先の保存
	 * @param paymentId
	 * @param param
	 */
	public async registerMedicineDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::registerMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			type: param.type,
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_REGISTER_MEDICINE_DELIVERY_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 自宅住所の更新
	 * @param paymentId
	 * @param param
	 */
	public async updateHomeAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::updateHomeAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_UPDATE_HOME_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * お薬送付先の更新
	 * @param paymentId
	 * @param param
	 */
	public async updateMedicineDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::updateMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
			type: param.type,
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_UPDATE_MEDICINE_DELIVERY_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * お薬送付先の削除
	 * @param paymentId
	 * @param param
	 */
	public async deleteMedicineDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::deleteMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_DELETE_MEDICINE_DELIVERY_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋送付先住所の保存
	 *
	 * @param paymentId
	 * @param param
	 */
	public async registerPrescriptionDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::registerPrescriptionDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			type: param.type,
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_REGISTER_PRESCRIPTION_DELIVERY_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋送付先の保存
	 * @param paymentId
	 * @param param
	 */
	public async updatePrescriptionDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::updatePrescriptionDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
			type: param.type,
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_UPDATE_PRESCRIPTION_DELIVERY_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋送付先の削除
	 * @param paymentId
	 * @param param
	 */
	public async deletePrescriptionDeliveryAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::deletePrescriptionDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_DELETE_PRESCRIPTION_DELIVERY_ADDRESS, request);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋をFAXする薬局の登録
	 * @param paymentId
	 * @param param
	 */
	public async registerStoreAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::registerMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			type: 'STORE',
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber,
			fax_number: param.faxNumber,
			store_name: param.storeName
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_REGISTER_STORE_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋FAX先の更新
	 * @param paymentId
	 * @param param
	 */
	public async updateStoreAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::registerMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
			type: 'STORE',
			post_code: param.postCode,
			prefecture: param.prefecture,
			city: param.city,
			address: param.address,
			building: param.building,
			to_name: param.toName,
			tel_number: param.telNumber,
			fax_number: param.faxNumber,
			store_name: param.storeName
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_UPDATE_STORE_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * 処方箋FAX先住所の削除
	 * @param paymentId
	 * @param param
	 */
	public async deleteStoreAddress(paymentId: number, param: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {

		this.log('ExamAfterProcessDAO::registerMedicineDeliveryAddress()');
		const request = {
			t: this.token,
			payment_id: paymentId,
			user_delivery_address_id: param.id,
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_DELETE_STORE_ADDRESS, request);
		this.log(ret);

		const data = await this.convertToExamAfterProcessInitialData(ret);

		return data;
	}

	/**
	 * レスポンスをインターフェイスに合わせて変換
	 * @param data
	 * @private
	 */
	private async convertToExamAfterProcessInitialData(data: any): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const obj= {
			examAfterProcess: toCamel(data.exam_after_process),
			user: toCamel(data.user),
			payment: toCamel(data.payment),
			primaryAddress: toCamel(data.primary_address),
			isValidPrimaryAddress: data.is_valid_primary_address,
			storeAddressList: this.obj2Array(toCamel(data.store_address_list)),
			homeAddressList: this.obj2Array(toCamel(data.home_address_list)),
			selectedPrescriptionDeliveryAddress: toCamel(data.selected_prescription_delivery_address),
			selectedPrescriptionFaxStore: toCamel(data.selected_prescription_fax_store),
			selectedMedicineDeliveryAddress: toCamel(data.selected_medicine_delivery_address),
			countAvailableMedicineDeliveryAddress: data.count_available_medicine_delivery_address,
			countAvailableStoreDeliveryAddress: data.count_available_store_delivery_address,
			isInputComplete: data.is_input_complete,
			epsilon: toCamel(data.epsilon)
		} as ExamAfterProcessInitialDataDTOInterface;

		return obj;
	}


	/**
	 * URLの作成
	 * @param paymentId
	 */
	public async createPaymentUrl(paymentId: number): Promise<any> {

		this.log('ExamAfterProcessDAO::registerMedicineDeliveryAddress()');
		console.log(paymentId);
		const request = {
			t: this.token,
			payment_id: paymentId,
		};
		this.log(request);
		const ret = await this.postRequest(AppSettingApi.EXAM_AFTER_PROCESS_CREATE_PAYMENT_URL, request);

		return toCamel(ret);
	}
}
